import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { Observable, startWith, Subscription, takeUntil } from 'rxjs';

import { AsyncPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DefaultIcon } from '@summit/core';
import { SummitIdObject } from '@summit/models';
import { Checkbox } from 'primeng/checkbox';
import { SummitControl } from '../../models';
import { SFormErrorInputComponent } from '../s-form-error-input';

@Component({
  selector: 's-form-input-checkbox',
  templateUrl: './s-form-input-checkbox.component.html',
  styleUrls: ['./s-form-input-checkbox.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, SFormErrorInputComponent, Checkbox, AsyncPipe, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SFormInputCheckboxComponent<T extends SummitIdObject>
  extends SummitControl<T>
  implements OnInit, OnChanges
{
  /* if there is a nullable then binary false */
  @Input() disabled$: Observable<boolean>;
  @Input() displayHint$: Observable<string>;
  @Input() allowNull$: Observable<boolean>;
  lclAllowNull = false;
  isNull = false;
  triStateValue: boolean | null;
  disableSubscription: Subscription;

  defaultIcon = DefaultIcon;

  override ngOnInit() {
    super.ngOnInit();
    this.allowNull$?.pipe(takeUntil(this.disposing$)).subscribe((allowLocal) => {
      //console.log('setting lcl allow null', allowLocal);
      this.lclAllowNull = allowLocal;
      this.cd.detectChanges();
    });

    //console.log(`FormInputCheckboxComponent.ngOnInit() ${this.fieldName}`, this.form.controls[this.fieldName]);
    if (this.nullableLabel) this.lclAllowNull = true;

    if (this.fieldName && this.form.controls[this.fieldName]) {
      this.form.controls[this.fieldName].valueChanges
        .pipe(startWith(this.form.controls[this.fieldName].value), takeUntil(this.disposing$))
        .subscribe((value) => {
          //console.log(`${this.fieldName.toString()}: watching value changes '${value}'`, value);
          if (value === undefined && !this.lclAllowNull) {
            this.form.controls[this.fieldName].patchValue(false);
            value = false;
            //this.cd.detectChanges();
          }
          if (value === undefined || value === null) {
            this.isNull = true;
            this.triStateValue = null;
          } else {
            this.isNull = false;
            this.triStateValue = value;
          }
          this.cd.detectChanges();
        });
    }

    if (this.disabled$) {
      this.disableSubscription = this.disabled$.pipe(takeUntil(this.disposing$)).subscribe((disabled) => {
        if (disabled) {
          this.form.controls[this.fieldName].disable();
        } else {
          this.form.controls[this.fieldName].enable();
        }
      });
    }
    // console.log(`id = ${this.htmlId}`);
  }

  override ngOnChanges(_changes: SimpleChanges): void {
    if (this.disabled$) {
      if (this.disableSubscription) {
        this.disableSubscription.unsubscribe();
      }
      this.disableSubscription = this.disabled$.pipe(takeUntil(this.disposing$)).subscribe((disabled) => {
        if (disabled) {
          this.form.controls[this.fieldName].disable();
        } else {
          this.form.controls[this.fieldName].enable();
        }
      });
    }
    super.ngOnChanges(_changes);
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
    event.preventDefault();
  }
  // stopPropagation(event: Event) {

  toggle() {
    if (this.form.controls[this.fieldName].disabled) return;
    // console.log('toggle', this.lclAllowNull, this.form.controls[this.fieldName].value, this.isNull);
    if (this.lclAllowNull && this.form.controls[this.fieldName].value === false) {
      // console.log('setting null', this.form.controls[this.fieldName].value);
      this.form.controls[this.fieldName].patchValue(null);
      this.isNull = true;
      this.triStateValue = null;
    } else if (this.form.controls[this.fieldName].value === true) {
      // console.log('setting false', this.form.controls[this.fieldName].value);
      this.form.controls[this.fieldName].patchValue(false);
      this.isNull = false;
      this.triStateValue = false;
    } else {
      // console.log('setting true', this.form.controls[this.fieldName].value);
      this.form.controls[this.fieldName].patchValue(true);
      this.isNull = false;
      this.triStateValue = true;
    }
    this.cd.detectChanges();
  }
}
